<button
  mat-icon-button
  type="button"
  class="mat-elevation-z1"
  [matMenuTriggerFor]="colorMenu"
  (menuOpened)="onMenuOpen()"
  [ngClass]="'mat-'+selectedPalette+'-'+selectedHue+'-bg'"
>
  <mat-icon>palette</mat-icon>
</button>

<mat-menu #colorMenu="matMenu" class="nk-material-color-picker-menu">
  <header
    [ngClass]="selectedColor?.class || 'mat-accent-bg'"
    (click)="$event.stopPropagation(); $event.preventDefault()"
    (keydown.enter)="$event.stopPropagation(); $event.preventDefault()"
    (keydown.space)="$event.stopPropagation(); $event.preventDefault()"
    tabindex="0"
    class="mat-elevation-z4"
    fxLayout="row"
    fxLayoutAlign="space-between center"
  >
    <button
      mat-icon-button
      [style.visibility]="view === 'hues' ? 'visible' : 'hidden'"
      (click)="$event.stopPropagation(); backToPaletteSelection()"
      aria-label="Palette"
    >
      <mat-icon>arrow_back</mat-icon>
    </button>

    <span *ngIf="selectedColor?.palette">
      {{ selectedColor.palette | dashToTitle }} {{ selectedColor.hue }}
    </span>
    <span *ngIf="!selectedColor?.palette">Select Color</span>

    <button
      mat-icon-button
      class="remove-color-button"
      (click)="$event.stopPropagation(); removeColor()"
      aria-label="Remove Color"
    >
      <mat-icon>delete</mat-icon>
    </button>
  </header>

  <div
    class="views"
    (click)="$event.stopPropagation(); $event.preventDefault()"
    (keydown.enter)="$event.stopPropagation(); $event.preventDefault()"
    (keydown.space)="$event.stopPropagation(); $event.preventDefault()"
    tabindex="0"
  >
    <!-- Palette Selection View -->
    <div
      class="view"
      [style.transform]="'translateX(' + (view === 'hues' ? '-100%' : '0') + ')'"
    >
      <div fxLayout="row wrap" fxLayoutAlign="start start" class="colors h100p">
        <div
          class="color"
          *ngFor="let color of objectKeys(colors)"
           
  [ngClass]="'mat-' + color + '-bg'"
  (click)="$event.stopPropagation(); selectPalette(color)"
         
          (keydown.enter)="$event.stopPropagation(); selectPalette(color)"
          (keydown.space)="$event.stopPropagation(); selectPalette(color)"
          tabindex="0"
          fxLayout="row"
          fxLayoutAlign="start start"
          mat-ink-ripple
        ></div>
      </div>
    </div>

    <!-- Hue Selection View -->
    <div
      class="view"
      [style.transform]="'translateX(' + (view !== 'hues' ? '100%' : '0') + ')'"
    >
      <div fxLayout="row wrap" fxLayoutAlign="start start" class="colors h100p">
        <div
          class="color"
         *ngFor="let hue of getHueFromPalette(selectedPalette)"
          [class.br50p]="(selectedHue || '500') === hue"
          [ngClass]="'mat-' + selectedPalette + '-' + hue + '-bg'"
          (click)="$event.stopPropagation(); selectHue(hue)"
          (keydown.enter)="$event.stopPropagation(); selectHue(hue)"
          (keydown.space)="$event.stopPropagation(); selectHue(hue)"
          tabindex="0"
          fxLayout="row wrap"
          fxLayoutAlign="start start"
          mat-ink-ripple
        ></div>
      </div>
    </div>
  </div>
</mat-menu>
